import type { Permission } from '@repo/contracts';
import { Navigate, Outlet } from 'react-router';

import { APP_ROUTES } from '@/constants/app-routes';
import { selectCan } from '@/store/auth.slice';
import { useAppSelector } from '@/store/store';

interface RequirePermissionProps {
  permission: Permission;
}

/**
 * Turns a page away before it mounts, so it never fires the requests the
 * gateway would refuse. The home page needs only a session, so it is always a
 * safe place to send someone and this cannot loop.
 */
export function RequirePermission({ permission }: RequirePermissionProps) {
  const allowed = useAppSelector(selectCan(permission));

  if (!allowed) return <Navigate to={APP_ROUTES.home} replace />;

  return <Outlet />;
}
